export default __webpack_public_path__ + "static/media/filterBadge.c1d25dd9.svg";